import { Component, Input, OnInit } from '@angular/core';
import { PVModuleModel } from '@bo-client/activation-management/grid-registration/model/pv-module.model';

@Component({
  selector: 'app-pv-modules-summary',
  templateUrl: './pv-modules-summary.component.html',
  styleUrls: ['../../../../../../shared/summaries/css-summary.component.scss']
})
export class PvModulesSummaryComponent implements OnInit {
  @Input() pvModules: PVModuleModel[] = [];
  @Input() showOnlyTotal = false;

  constructor() {}

  ngOnInit(): void {}
}
